<soft-page>
  <soft-page-header>
    <div>
      <p class="soft-title">
        {{ '#SELF_CHECKOUT_CONFIG.WORKSTATION.HEADER_TITLE' | translate }}
      </p>
      <p class="text-sm text-light">
        {{ '#SELF_CHECKOUT_CONFIG.WORKSTATION.HEADER_SUBTITLE' | translate }}
      </p>
    </div>
  </soft-page-header>
  <div class="w-full">
    <label class="soft-label top block mb-2" for="kasse">Name</label>
    <soft-field-ok
      fieldOkName="kasse"
      placeholder="Kassa auswählen"
      [(value)]="workstation"
    />
  </div>
</soft-page>
